import { render, staticRenderFns } from "./RemunerationManaged.vue?vue&type=template&id=048263c3&scoped=true&"
import script from "./RemunerationManaged.vue?vue&type=script&lang=js&"
export * from "./RemunerationManaged.vue?vue&type=script&lang=js&"
import style0 from "./RemunerationManaged.vue?vue&type=style&index=0&id=048263c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048263c3",
  null
  
)

export default component.exports